import React from 'react';
import { GetServerSideProps } from 'next';
import CenteredContainer from '@/common/CenteredContainer';
import SupplierCodeOfConductPage from '@/shared/pages/supplier-code-of-conduct';
import initializePage from '../app/common/pageSetup';

const SupplierCodeOfConduct = (): JSX.Element => (
    <>
      <CenteredContainer>
        <SupplierCodeOfConductPage />
      </CenteredContainer>
    </>
  );

export const getServerSideProps: GetServerSideProps = (ctx) => initializePage(ctx, 'supplier-code-of-conduct');

export default SupplierCodeOfConduct;
